import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Button } from "../../../../components/inputs/button/button";
import storeSBRPageMixPanel, { SBR_PAGE_MIXPANEL_EVENT } from "../../sbr-page-mixpanel-store";
import './schedule-demo-card.scss';

interface IScheduleDemoCardProps {
    onSetUpClicked: () => void
}

const ScheduleDemoCard: React.FC<IScheduleDemoCardProps> = ({ onSetUpClicked }) => {
    const onLinkClicked = (url: string) => {
        storeSBRPageMixPanel.trackEvent(SBR_PAGE_MIXPANEL_EVENT.SCHEDULE_DEMO_CLICKED, {});
        window.open(url, '_blank');
    };

    return (
        <div className={'schedule-demo-card'}>
            <div className={'schedule-demo-card-content'}>
                <FontHeading2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                    Enjoy the Best Shipping Rates, with No Extra Effort
                </FontHeading2>
                <FontBody1>
                    Ship by ReturnGO is our in-house shipping solution that is automatically integrated
                    into your system. Effortlessly set up Ship by ReturnGO today to enjoy our negotiated
                    label costs. <span className={'schedule-demo-card-text-link'} onClick={() => onLinkClicked("https://support.returngo.ai/ship-by-returngo")}>
                        <FontBody1 variant={FONT_VARIANT.UNDER_LINE} color={FONT_COLOR.ACCENT1}>Learn more</FontBody1>
                    </span>
                </FontBody1>
                <div className={'schedule-demo-card-buttons'}>
                    <Button onClick={() => onLinkClicked("https://meetings.hubspot.com/returngo/onboarding-session")} text="Schedule a demo" variant={BUTTON_VARIANTS.Tertiary} />
                    <Button text="Set up now" variant={BUTTON_VARIANTS.PrimaryAccent} onClick={onSetUpClicked} />
                </div>
            </div>
        </div>
    );
};

export default ScheduleDemoCard;